export const patternDataKey = /^[a-zA-Z0-9_:]{1,63}$/;
export const startsWithAlphabetOrUnderscoreDataKey = /^[a-zA-Z_]/;
export const dataTypes = [
  "SMALLINT", // 'INT2',
  "INTEGER", // 'INT', 'INT4',
  "BIGINT", // 'INT8',
  "DECIMAL(18,0)", // 'NUMERIC',
  "REAL", // 'FLOAT4',
  "DOUBLE PRECISION", // 'FLOAT8', 'FLOAT',
  "BOOLEAN", // 'BOOL',
  "CHAR(16)", // 'CHARACTERNCHAR', 'BPCHAR',
  "VARCHAR(256)", // 'CHARACTER VARYING', 'NVARCHAR', 'TEXT',
  "DATE",
  "TIMESTAMP", // 'TIMESTAMP WITHOUT TIME ZONE',
  "RECORD", // BigQueryだけ
  "JSON", // BigQueryだけ
];

export enum PartitionKey {
  Unspecified = "",
  NcRecordedAt = "nc_recorded_at",
  PostedAt = "posted_at",
  LcRecordedAt = "lc_recorded_at",
}

export enum ClusteringField {
  Unspecified = "",
  NsaId = "nsa_id",
  SerialNumber = "serial_number",
  DeviceId = "device_id",
  DeviceId2 = "device_id2",
}

export const dataTypePatterns = [
  /^SMALLINT$/,
  /^INTEGER$/,
  /^BIGINT$/,
  /^DECIMAL\([0-9]+,[0-9]+\)$/,
  /^REAL$/,
  /^DOUBLE PRECISION$/,
  /^BOOLEAN$/,
  /^CHAR\([0-9]+\)$/,
  /^VARCHAR\([0-9]+\)$/,
  /^DATE$/,
  /^TIMESTAMP$/,
  /^RECORD$/,
  /^JSON$/,
];

export const bigqueryReservedKeys = [
  "all",
  "and",
  "any",
  "array",
  "as",
  "asc",
  "assert_rows_modified",
  "at",
  "between",
  "by",
  "case",
  "cast",
  "collate",
  "contains",
  "create",
  "cross",
  "cube",
  "current",
  "default",
  "define",
  "desc",
  "distinct",
  "else",
  "end",
  "enum",
  "escape",
  "except",
  "exclude",
  "exists",
  "extract",
  "false",
  "fetch",
  "following",
  "for",
  "from",
  "full",
  "group",
  "grouping",
  "groups",
  "hash",
  "having",
  "if",
  "ignore",
  "in",
  "inner",
  "intersect",
  "interval",
  "into",
  "is",
  "join",
  "lateral",
  "left",
  "like",
  "limit",
  "lookup",
  "natural",
  "new",
  "not",
  "null",
  "merge",
  "no",
  "nulls",
  "of",
  "on",
  "or",
  "order",
  "outer",
  "over",
  "partition",
  "preceding",
  "proto",
  "range",
  "recursive",
  "respect",
  "right",
  "rollup",
  "rows",
  "select",
  "set",
  "some",
  "struct",
  "tablesample",
  "then",
  "to",
  "treat",
  "true",
  "unbounded",
  "union",
  "unnest",
  "using",
  "when",
  "where",
  "window",
  "with",
  "within",
];

export const envColors: { [index: string]: string } = {
  lp1: "danger",
  jd1: "info",
  dd1: "primary",
};

export enum layoutModes {
  leftOnly = "leftOnly",
  rightOnly = "rightOnly",
  both = "both",
}

export type LayoutModes = "leftOnly" | "rightOnly" | "both";

export const timeZones: { [index: string]: string } = {
  JST: "JST(+0900)",
  UTC: "UTC(+0000)",
};

export type TimeZones = "JST" | "UTC";
